import React, { useMemo } from "react";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import CheckoutForm from "./CheckoutForm";
import "./Payment.css";

//import CardSetupForm from "./CardSetupForm";
// Make sure to call loadStripe outside of a component’s render to avoid
// recreating the Stripe object on every render.
// loadStripe is initialized with your real test publishable API key.
//const promise = loadStripe("pk_live_51IADmSKlhPOauEXY8EncpOFkfm9xph2kwHKnH1GewT2nZbJSC6FyfkyKVpstAzVgXH3clbdR0sp1I7O3961gbtSm00vqZnNEoW");
//const promise = loadStripe("pk_test_51IADmSKlhPOauEXYp2z9xU5dZ6C8Z1H8LEEHTaejPWZyGYKyDdbH9Y63fVwpG4TElmOvNOzaZq5KK7oVJOdDhbX200j87KWl4R");


export default function PaymentContainer(props) {

    //const promise = loadStripe(props.reservation.paymentKey)  //paymentKey updated from roomType;
    const stripePromise = useMemo(() => {
        //if (!props.reservation?.paymentKey) return null;
        return loadStripe(props.reservation.paymentKey);
        //return loadStripe("pk_test_51IADmSKlhPOauEXYp2z9xU5dZ6C8Z1H8LEEHTaejPWZyGYKyDdbH9Y63fVwpG4TElmOvNOzaZq5KK7oVJOdDhbX200j87KWl4R");
    }, [props.reservation?.paymentKey]);

    if (!stripePromise) {
        return <div>Preparing payment...</div>;
    }
   
    return (
        <div className="App">
            <Elements stripe={stripePromise}>
                <CheckoutForm
                    reservation={props.reservation}
                    setPageState={props.setPageState}
                />
            </Elements>
        </div>
    );
}